import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "grid grid-cols-4 gap-6" };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["aria-label"];
const _hoisted_4 = ["id"];
const _hoisted_5 = { class: "text-sm text-slate-500" };
const _hoisted_6 = { class: "my-loading" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Loading = _resolveComponent("Loading");
    const _component_VueEternalLoading = _resolveComponent("VueEternalLoading");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.index.getData(), (report) => {
                return (_openBlock(), _createElementBlock("a", {
                    href: "#",
                    class: "bg-white p-6 rounded-xl col-span-4 xl:col-span-1 cursor-pointer border-4 hover:border-brand-500",
                    onClick: _withModifiers(($event) => (_ctx.showReport(report)), ["prevent"])
                }, [
                    (_openBlock(), _createElementBlock("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "h-40 w-40 mx-auto text-slate-200",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor",
                        focusable: "false",
                        role: "img",
                        "aria-label": report.name
                    }, [...(_cache[0] || (_cache[0] = [
                            _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"
                            }, null, -1),
                            _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"
                            }, null, -1)
                        ]))], 8, _hoisted_3)),
                    _createElementVNode("h2", {
                        id: report.name,
                        class: "font-medium text-slate-800"
                    }, _toDisplayString(_ctx.f.ellipsis(report.name, 32)), 9, _hoisted_4),
                    _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.f.ellipsis(report.description, 40)), 1)
                ], 8, _hoisted_2));
            }), 256))
        ]),
        _createVNode(_component_VueEternalLoading, { load: _ctx.load }, {
            loading: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_Loading, { message: "Loading Reports" })
                ])
            ]),
            "no-more": _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("div", { class: "my-no-more" }, [
                        _createElementVNode("div", { class: "my-6 text-center" }, [
                            _createElementVNode("a", {
                                href: "#campaigns",
                                class: "flex justify-center"
                            }, [
                                _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    class: "h-5 w-5 mr-2",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    focusable: "true"
                                }, [
                                    _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        d: "M5 10l7-7m0 0l7 7m-7-7v18"
                                    })
                                ]),
                                _createTextVNode(" Top of Page ")
                            ])
                        ])
                    ], -1)
                ]))]),
            "no-results": _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("div", { class: "no-results panel p-10 mt-4" }, [
                        _createElementVNode("div", { class: "text-slate-300 my-6" }, [
                            _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                class: "h-20 w-20 mx-auto",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                "stroke-width": "2"
                            }, [
                                _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    d: "M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"
                                }),
                                _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    d: "M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"
                                })
                            ])
                        ]),
                        _createElementVNode("h2", { class: "text-slate-600 font-medium text-2xl text-center" }, "No Reports Available"),
                        _createElementVNode("p", { class: "text-center mt-4 text-sm text-slate-700" }, " We could not find any reports. ")
                    ], -1)
                ]))]),
            error: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createElementVNode("div", { class: "no-results panel p-10 mt-4" }, [
                        _createElementVNode("div", { class: "text-slate-300 my-6" }, [
                            _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                class: "h-20 w-20 mx-auto",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                role: "img",
                                focusable: "false",
                                "aria-label": "An Error Occurred"
                            }, [
                                _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                })
                            ])
                        ]),
                        _createElementVNode("h2", { class: "text-slate-600 font-medium text-2xl text-center" }, "An Error Occurred"),
                        _createElementVNode("p", { class: "text-center mt-4 text-sm text-slate-700" }, " An error occurred, please try again. If this problem persists please contact support. ")
                    ], -1)
                ]))]),
            _: 1
        }, 8, ["load"])
    ]));
}
